import { createContext } from 'react';
import { ContextWrapper } from '../../config/constants';
import { ReferralActions, ReferralStateType } from './refferalTypes';

const referralContext = createContext(
    {} as ContextWrapper<ReferralStateType, ReferralActions>
);

export default referralContext;
